import { isLocalStorageAvailable } from 'wanderu-utils';

import inMemoryCurrencyStore from './inMemoryCurrencyStore';
import localStorageCurrencyStore from './localStorageCurrencyStore';

function setConversionRates(conversionRates) {
    _getTargetCurrencyStore().setConversionRates(conversionRates);
}

function getConversionRates() {
    return _getTargetCurrencyStore().getConversionRates();
}

function _getTargetCurrencyStore() {
    if (isLocalStorageAvailable()) {
        return localStorageCurrencyStore;
    }

    return inMemoryCurrencyStore;
}

function getSupportedCurrencies() {
    return _getTargetCurrencyStore().getSupportedCurrencies();
}

function setSupportedCurrencies(supportedCurrencies) {
    return _getTargetCurrencyStore().setSupportedCurrencies(supportedCurrencies);
}

export {
    getConversionRates,
    getSupportedCurrencies,
    setConversionRates,
    setSupportedCurrencies,
};

export default {
    getSupportedCurrencies,
    setSupportedCurrencies,
    getConversionRates,
    setConversionRates,
};
